const escapedCharsRegex = /[,"\n\r]/;


export type CsvColumn<T> = {
    header: string,
    value: (row: T) => string,
};

export class CsvModel<T> {
    constructor(public readonly columns: CsvColumn<T>[]) {
    }

    csvString(rows: T[]): string {
        const stringBuilder: string[] = [];

        this.columns.forEach((column, index) => {
            if (index > 0) stringBuilder.push(',');
            stringBuilder.push(CsvModel.csvEscape(column.header));
        });

        rows.forEach(row => {
            stringBuilder.push('\n');
            this.columns.forEach((column, index) => {
                if (index > 0) stringBuilder.push(',');
                stringBuilder.push(CsvModel.csvEscape(column.value(row)));
            });
        });

        return stringBuilder.join('');
    }

    csvBlob(rows: T[]): Blob {
        const content = this.csvString(rows);
        const bom = '\uFEFF'; // Excel-friendly
        return new Blob([bom + content], {type: 'text/csv;charset=utf-8;'});
    }

    downloadCsv(fileName: string, rows: T[]) {
        const blob = this.csvBlob(rows);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    private static csvEscape(value: string): string {
        // Escape quotes
        const escaped = value.replaceAll('"', '""');

        // Wrap in quotes if contains comma, quote or newline
        if (escapedCharsRegex.test(escaped)) {
            return `"${escaped}"`;
        } else {
            return escaped;
        }
    }
}
